// extracted by mini-css-extract-plugin
module.exports = {"itemName":"ExpandableMenuItem_itemName__p8_kr","hoveredItem":"ExpandableMenuItem_hoveredItem__rlNdj"};